module.exports = __webpack_public_path__ + "static/media/ADSlogo.34d68173.png";